.pane {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  padding: 20px;
}

.label {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.when {
  display: flex;
  align-items: center;
  gap: 14px;
}

.tile {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 60px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent-soft);
}

.month {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.number {
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.lines {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.time {
  font-size: 17px;
  font-weight: 700;
}

.details {
  font-size: 14px;
  color: var(--ink-2);
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding-top: 4px;
  font-size: 15px;
}

.before {
  font-weight: 600;
}

.count {
  color: var(--ink-2);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
